import React from 'react';
import { bookingUrl, images } from '../data/site';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section id="book" className="relative flex min-h-[80svh] w-full items-center justify-center overflow-hidden bg-ocean-deep" data-id="element-77" data-mp="vghgnn67c9ny">
      <img src={images.cta} alt="Aerial view of the Taveuni coastline at sunset" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-78" data-mp="15ddgz5ly5phf" />
      <div className="absolute inset-0 bg-ocean-deep/65" data-id="element-79" data-mp="1jasbupuyypgs" />

      <Reveal className="relative mx-auto max-w-3xl px-5 py-28 text-center sm:px-8 lg:py-36" data-id="element-80" data-mp="1ed8yds63igpw">
        <h2 className="font-serif text-[clamp(2.25rem,6vw,5rem)] font-light leading-[1.05] text-ivory" data-id="element-81" data-mp="1t1mz9xjybv3t">
          Ready to experience
          <span className="block italic text-gold-soft" data-id="element-82" data-mp="1o5y4s8msh4ed">Taveuni?</span>
        </h2>
        <p className="mx-auto mt-7 max-w-lg text-[17px] leading-relaxed text-ivory/80" data-id="element-83" data-mp="223w90l7ebkg5">
          Stay local. Explore the island. Wake up in paradise.
        </p>
        <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="mt-11 inline-block rounded-full bg-ivory px-11 py-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-forest-deep transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:bg-gold hover:shadow-lift" data-id="element-84" data-mp="n6e4lks7mfvu">
          Book your stay
        </a>
        <p className="mt-5 text-[12px] uppercase tracking-[0.16em] text-ivory/55" data-id="element-85" data-mp="165044v82vyxn">
          Check availability and rates.
        </p>
      </Reveal>
    </section>;
}